<template>
  <!-- 附件上传 -->
  <div style="width: 100%;">
    <!-- <a-upload-dragger
      name="file"
      :multiple="true"
      :action="action"
      :headers="headers"
      :show-upload-list="false"
      @change="handleChange"
      v-if="uploadIf"
    >
      <p class="ant-upload-drag-icon">
        <a-icon type="inbox" />
      </p>
      <p class="ant-upload-text">
        可点击或拖拽上传附件
      </p>
      <p class="ant-upload-hint">
        支持多个文件、多种格式(.png, .jpg, .txt, .doc, .docx, .xls, .xlsx, .pdf, .zip, .rar)多次上传
      </p>
    </a-upload-dragger> -->
    <a-upload
      name="file"
      :multiple="false"
      :action="action"
      :headers="headers"
      :show-upload-list="false"
      @change="handleChange"
      v-if="uploadIf"
    >
      <a-button  size="small"> <a-icon type="upload"/> 点击上传附件 </a-button>
      <!-- <span style="margin-left: 20px;">
        <a-icon type="info-circle"  theme="twoTone"/>
        支持单个文件、多种格式(.png, .jpg, .txt, .doc, .docx, .xls, .xlsx, .pdf, .zip, .rar)多次上传
      </span> -->
    </a-upload>
    <!-- <div v-if="fileObj && fileObj.length > 0">
      <a-divider orientation="left" v-if="uploadIf">已上传附件列表</a-divider>
      <a-table
        size="small"
        bordered
        :columns="columns"
        :data-source="fileObj"
        :pagination="false"
        :rowKey="(record,index)=>{return index}"
      >
        <template slot="operation" slot-scope="text, record, index">
          <a-icon v-if="isPreview(record)" class="icon-pointer" type="eye" :style="{ color: 'blue' }" title="预览" @click="showClick(record, index)" style="margin-right: 10px;"/>
          <a-icon class="icon-pointer" type="cloud-download" :style="{ color: 'blue' }" title="下载" @click="downloadClick(record)" style="margin-right: 10px;"/>
          <span>
            <a-popconfirm title="附件一旦删除不可恢复，是否确定删除？" ok-text="确定" cancel-text="取消" v-if="uploadIf" @confirm="deleteFileClick(record.id)">
              <a-icon class="icon-pointer" type="delete" style="color: red;cursor:pointer; " title="删除" />
            </a-popconfirm>
          </span>
        </template>
      </a-table>
    </div> -->
    <!-- <div v-else>
      <a-divider orientation="center" v-if="uploadIfNo">暂无附件</a-divider>
    </div> -->
    <!-- <a-modal class="preViewCla" :visible="previewVisible" :footer="null" @cancel="previewCacel">
      <div class="box" ref="box">
        <div class="avatar" ref="avatar">
          <img :src="previewImage" draggable="false" style="width: 100%;">
        </div>
      </div>
    </a-modal> -->
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewCacel">
      <!-- <img-zoom ref="imgRef"/> -->
      <div class="modal_box">
        <!-- <h1  >《</h1> -->
        <a-icon type="left-circle" class="tubiaoLeft" @click="imgPrev"/>
        <a-carousel v-if="yulanArr && yulanArr.length>0" arrows dots-class="slick-dots slick-thumb" ref="img">
          <div v-for="(item, index) in yulanArr" :key="index">
            <p><b>{{item.oldName}}</b></p>
            <div>
              <img class="img" style="height: auto;width:100%;" :src="item.showImgUrl" />
            </div>
          </div>
        </a-carousel>
        <a-icon type="right-circle" class="tubiaoRight" @click="imgNext" />
        <!-- <h1 @click="imgNext" class="rightLeft">》</h1> -->
      </div>
    </a-modal>
  </div>
</template>

<script>
import axios from 'axios'
import imgZoom from './imgZoom.vue'
export default {
  components: { imgZoom },
  props: {
    valName: {
      type: String,
      default: 'fileIds'
    },
    uploadIf: {
      type: Boolean,
      default: true
    },
    uploadIfNo: {
      type: Boolean,
      default: true
    }
  },
  inject: ['formData'],
  comments: {
    imgZoom
  },
  data () {
    return {
      action: this.$baseURL + '/file/uploadFile',
      headers: {
        Authentication: this.$store.state.account.token
      },
      fileObj: [], // 储存对象 便于数据展示
      fileIdList: [], // 储存id便于数据传输
      columns: [
        {
          width: '30%',
          ellipsis: true,
          title: '文件名',
          dataIndex: 'oldName',
          align: 'center'
        },
        {
          title: '上传时间',
          dataIndex: 'time',
          align: 'center'
        }, {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      setCount: 0,
      uploadSuccObj: [], // 存储上传新得附件的对象
      uploadSuccList: [], // 存储上传新得附件的id
      lastDelId: '', // 上次删除id
      previewVisible: false,
      previewImage: '',
      yulanArr: []
    }
  },
  mounted () {
  },
  methods: {
    handleChange (info) {
      this.uploadSuccObj = []
      this.uploadSuccList = []
      const resFile = info.fileList
      if (info.file.status === 'done') {
        if (info.file.response.status) {
          this.$message.success('上传附件成功')
          // 判断展示的list数组是否包含上传成功的id
          resFile.forEach(item => {
            if (this.fileIdList.indexOf(item.response.file.fileId) === -1) {
              if (item.response.file.fileId !== this.lastDelId) {
                this.uploadSuccObj.push({
                  id: item.response.file.fileId,
                  oldName: item.response.file.oldName,
                  time: item.response.file.time,
                  accessUrl: item.response.file.accessUrl,
                  fileSuffix: item.response.file.fileSuffix
                })
                this.uploadSuccList.push(item.response.file.fileId)
              }
            }
          })
          this.$emit('uploadChange', this.uploadSuccObj)
          this.setValue(true)
        } else {
          this.$message.error(info.file.response.message)
        }
      }
    },
    getFile (idList) { // 查询附件详情
      this.fileObj = []
      this.fileIdList = []
      for (let k = 0; k < idList.length; k++) {
        this.$get('/file/getFileById', { fileId: idList[k] }).then(res => {
          this.fileObj.push({
            id: res.data.data.fileId,
            oldName: res.data.data.oldName,
            time: res.data.data.time,
            accessUrl: res.data.data.accessUrl,
            fileSuffix: res.data.data.fileSuffix
          })
          this.fileIdList.push(res.data.data.fileId)
        })
      }
      if (idList.length > 0) {
        this.setValue(false)
      }
      setTimeout(() => {
        this.getUrlDetails()
      }, 200)
    },
    getUrlDetails () {
      // 循环附件对象 存储字段-附件查看详情url
      this.fileObj.forEach(element => {
        let previewImage = ''
        const url = this.$baseURL + element.accessUrl
        axios({
          method: 'GET',
          url: url,
          responseType: 'arraybuffer',
          headers: {
            'Authentication': this.$store.state.account.token
          }
        }).then(res => {
          previewImage = 'data:image/png;base64,' + btoa(
            new Uint8Array(res.data)
              .reduce((data, byte) => data + String.fromCharCode(byte), '')
          )
          element.showImgUrl = previewImage
        }).catch((e) => {
          console.log(e)
          // this.$message.error('附件"' + element.oldName + '"加载失败！')
        })
      })
    },
    showClick (itemRow, indexVal) { // 预览附件
      this.previewVisible = true
      let arr = JSON.parse(JSON.stringify(this.fileObj))
      // 点击预览某一张时(不为第一张) 将数组调整顺序
      if (indexVal >= 0) {
        let firstArr = arr.splice(indexVal, this.fileObj.length)
        let endArr = arr.splice(0, indexVal)
        this.yulanArr = [...firstArr, ...endArr]
        // console.log('yulanArr', this.yulanArr)
      }
    },
    previewCacel () {
      this.previewVisible = false
      this.previewImage = ''
      this.yulanArr = []
    },
    isPreview (itemVal) { // 是否支持预览
      if (itemVal.fileSuffix === '.png' || itemVal.fileSuffix === '.jpg') {
        return true
      } else {
        return false
      }
    },
    downloadClick (itemVal) { // 下载附件
      this.$download('/file/downloadFile', { fileId: itemVal.id }, itemVal.oldName)
    },
    deleteFileClick (idVal) { // 删除附件
      this.$post('/file/deleteFile', { fileId: idVal }).then(res => {
        if (res.data.status) {
          this.lastDelId = idVal
          this.$message.success('删除附件成功')
          // 删除后台传输的id   删除展示的list
          this.fileObj = this.fileObj.filter(item => item.id !== idVal)
          this.fileIdList = this.fileIdList.filter(item => item !== idVal)
          // 判断删除是否为刚上传对象里的数据
          if (this.uploadSuccList.indexOf(idVal) !== -1) {
            this.uploadSuccObj = this.uploadSuccObj.filter(item => item.id !== idVal)
            this.uploadSuccList = this.uploadSuccList.filter(item => item !== idVal)
          }
          this.setValue(true)
        } else {
          this.$message.error('删除附件失败')
        }
      })
    },
    setValue (val) {
      this.fileIdList = [...this.fileIdList, ...this.uploadSuccList]
      this.fileObj = [...this.fileObj, ...this.uploadSuccObj]
      // 数组对象数据去重
      for (var i = 0; i < this.fileObj.length - 1; i++) {
        for (var j = i + 1; j < this.fileObj.length; j++) {
          if (this.fileObj[i].id === this.fileObj[j].id) {
            this.fileObj.splice(j, 1) // splice删除了一个元素，下标要减一，否则循环会漏掉一个元素(多个相邻的元素 可能会漏掉删除元素)
            j--
          }
        }
      }
      // 数组去重
      this.fileIdList = [...new Set(this.fileIdList)]
      if (val) {
        this.setCount++
        // 数组转string逗号分隔字符串
        const fileStr = this.fileIdList.join(',')
        // 子组件给父组件传值
        this.formData[this.valName] = fileStr
      }
    },
    closeData () {
      this.fileObj = []
      this.fileIdList = []
    },
    imgPrev () {
      this.$refs.img.prev()
      // console.log('上一张')
    },
    imgNext () {
      this.$refs.img.next()
      // console.log('下一张')
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-modal-body{
  padding: 40px 24px 30px !important;
}
/deep/ .ant-table-thead > tr > th{
  background-color: #efefef!important;
}
/deep/ .ant-table-small > .ant-table-content > .ant-table-body{
  margin: 0;
}
/deep/ .ant-modal{
  width: 50% !important;
}
.modal_box{
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  .tubiaoLeft{
    color:#096dd9;
    font-size: 34px;
    position: absolute;
    top: 30px;
    left: -2px;
    z-index: 99;
  }
  .tubiaoRight{
    color:#096dd9;
    font-size: 34px;
    position: absolute;
    top: 30px;
    right: -2px;
    z-index: 99;
  }
  .ant-carousel {
    width: 90%;
    margin: 0 10px;
  }
  // 未选中
  /deep/ .ant-carousel .slick-dots li button{
    background: #62bdfa;
  }
  // 选中
  /deep/ .ant-carousel .slick-dots li.slick-active button{
    background: #0288e2;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/common/attachmentUpload.vue